export default __webpack_public_path__ + "static/media/camry.79c8d057.png";